// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__28FYM","label":"SetPasswdForm_label__2umjg"};